<script setup>
import { useI18n } from 'vue-i18n';
import { checkId } from '../composables/salesReviewReturnSections';

const props = defineProps({
  definition: { type: Object, required: true },
  item: { type: Object, required: true },
  index: { type: Number, required: true },
  participants: { type: Array, default: () => [] },
  options: { type: Array, default: () => [] },
  readOnly: { type: Boolean, default: false },
  showErrors: { type: Boolean, default: false },
});

const emit = defineEmits(['target', 'checks']);
const { t } = useI18n();
const selectedCheckIds = () => (props.item.checks || []).map(checkId);
const participantLabel = participant =>
  participant.relation_type === 'representante'
    ? t('SALES.REVIEW.COMPOSER.REPRESENTATIVE_OPTION', {
        name: participant.name,
      })
    : participant.name;
const updateTarget = event => emit('target', props.index, event.target.value);
const updateChecks = event => {
  const ids = Array.from(event.target.selectedOptions, option => option.value);
  emit('checks', props.index, ids);
};
</script>

<template>
  <div class="grid gap-4 rounded-lais-sm bg-lais-bg-soft p-4">
    <label class="grid gap-2 text-sm font-medium text-lais-text">
      <span>{{ definition.personLabel }}</span>
      <select
        class="h-10 rounded-lais-sm border bg-white px-3 text-sm"
        :class="
          showErrors && !item.target_key
            ? 'border-lais-danger'
            : 'border-lais-border'
        "
        :value="item.target_key"
        :disabled="readOnly"
        @change="updateTarget"
      >
        <option value="">{{ t('SALES.REVIEW.COMPOSER.SELECT') }}</option>
        <option
          v-for="participant in participants"
          :key="participant.id"
          :value="participant.id"
        >
          {{ participantLabel(participant) }}
        </option>
      </select>
      <span
        v-if="showErrors && !item.target_key"
        class="text-xs text-lais-danger"
      >
        {{ t('SALES.REVIEW.RETURN_FORM.REQUIRED') }}
      </span>
    </label>
    <label class="grid gap-2 text-sm font-medium text-lais-text">
      <span>
        {{ definition.checksLabel
        }}{{ t('SALES.REVIEW.RETURN_FORM.REQUIRED_MARK') }}
      </span>
      <select
        multiple
        class="min-h-28 w-full rounded-lais-sm border bg-white p-2 text-sm"
        :class="
          showErrors && !item.checks?.length
            ? 'border-lais-danger'
            : 'border-lais-border'
        "
        :value="selectedCheckIds()"
        :disabled="readOnly || !item.target_key"
        @change="updateChecks"
      >
        <option
          v-for="option in options"
          :key="checkId(option)"
          :value="checkId(option)"
        >
          {{ option.name || option.nome }}
        </option>
      </select>
      <span class="text-xs font-normal text-lais-text-muted">
        {{ definition.checksPlaceholder }}
      </span>
      <span
        v-if="showErrors && !item.checks?.length"
        class="text-xs text-lais-danger"
      >
        {{ t('SALES.REVIEW.RETURN_FORM.REQUIRED') }}
      </span>
    </label>
  </div>
</template>
